import { render } from "./NeedQuestion.vue?vue&type=template&id=1bdbd511"
import script from "./NeedQuestion.vue?vue&type=script&lang=js"
export * from "./NeedQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__